module.exports = __webpack_public_path__ + "img/Bingo_Info_Game7.1a1d6fc2.png";